// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { EnrollmentVerifySurveyEntryResultModel } from './enrollmentVerifySurveyEntryResultModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class EnrollmentVerifySurveyEntryResultModelResponse {
    'success': boolean;
    'messages': Array<string>;
    'data': EnrollmentVerifySurveyEntryResultModel | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof EnrollmentVerifySurveyEntryResultModelResponse>> = [
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
        {
            "name":     "data",
            "baseName": "data",
            "type":     "EnrollmentVerifySurveyEntryResultModel"
        },
    ];

    static getAttributeTypeMap() {
        return EnrollmentVerifySurveyEntryResultModelResponse.attributeTypeMap;
    }
}
